module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "noaa-air-samples--cover.77397635.png";